import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

export interface AlterarFormaRecebimentoDialogData {
  quantidadeContas: number;
  formasRecebimento: { idFormaRecebimento: number; descricao: string }[];
}

export interface AlterarFormaRecebimentoDialogResult {
  confirm: boolean;
  idFormaRecebimento: number | null;
}

@Component({
  selector: 'app-alterar-forma-recebimento-dialog',
  standalone: true,
  imports: [
    FormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
  ],
  templateUrl: './alterar-forma-recebimento-dialog.component.html',
  styleUrl: './alterar-forma-recebimento-dialog.component.css',
})
export class AlterarFormaRecebimentoDialogComponent {
  public idFormaRecebimento: number | null = null;

  get qtdSelecionados(): number {
    return this.data.quantidadeContas;
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AlterarFormaRecebimentoDialogData,
    public dialogRef: MatDialogRef<AlterarFormaRecebimentoDialogComponent>
  ) {}

  public close(): void {
    this.dialogRef.close({ confirm: false } as AlterarFormaRecebimentoDialogResult);
  }

  public confirm(): void {
    this.dialogRef.close({
      confirm: true,
      idFormaRecebimento: this.idFormaRecebimento,
    } as AlterarFormaRecebimentoDialogResult);
  }
}
